import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Yubinuki, Procedure } from './Yubinuki';
import YubinukiProcedure from './YubinukiProcedure';

interface GroupProps {
    groupNo: number,
    procedures: Array<{ procedure: Procedure, index: number }>,
    tobi: number,

    onClickAddProcedure: ((groupNo: number) => void),

    onChangeOffset: ((procedureIndex: number, offset: number) => void),
    onChangeSasiType: ((procedureIndex: number, sasiType: number) => void),
    onChangeMatomeSasi: ((procedureIndex: number, matomeSasi: boolean) => void),
    onChangeConnectedRounds: ((procedureIndex: number, connectedRounds: number) => void),

    onClickMoveUpProcedure: ((procedureIndex: number) => void),
    onClickMoveDownProcedure: ((procedureIndex: number) => void),
    onClickDeleteProcedure: ((procedureIndex: number) => void),

    onChangeItoColor: ((procedureIndex: number, itoIndex: number, color: string) => void),
    onChangeItoRounds: ((procedureIndex: number, itoIndex: number, rounds: number) => void),
    onClickMoveUpIto: ((procedureIndex: number, itoIndex: number) => void),
    onClickMoveDownIto: ((proccedureIndex: number, itoIndex: number) => void),
    onClickDeleteIto: ((procedureIndex: number, itoIndex: number) => void),
    onClickAddIto: ((procedureIndex: number) => void),
}

function YubinukiProcedureGroup(props: GroupProps) {
    function handleAddProcedure() {
        props.onClickAddProcedure(props.groupNo);
    }

    let procedures = props.procedures.map(({ procedure, index }) => {
        return (
            <YubinukiProcedure
                key={index}
                index={index}
                tobi={props.tobi}
                procedure={procedure}

                onChangeOffset={props.onChangeOffset}
                onChangeSasiType={props.onChangeSasiType}
                onChangeMatomeSasi={props.onChangeMatomeSasi}
                onChangeConnectedRounds={props.onChangeConnectedRounds}
                onClickMoveUpProcedure={props.onClickMoveUpProcedure}
                onClickMoveDownProcedure={props.onClickMoveDownProcedure}
                onClickDeleteProcedure={props.onClickDeleteProcedure}
                onChangeItoColor={props.onChangeItoColor}
                onChangeItoRounds={props.onChangeItoRounds}
                onClickMoveUpIto={props.onClickMoveUpIto}
                onClickMoveDownIto={props.onClickMoveDownIto}
                onClickDeleteIto={props.onClickDeleteProcedure}
                onClickAddIto={props.onClickAddIto}
                />
        );
    });

    return (
        <div className="card bg-light mb-2">
            <div className="card-header">
                <h3 className="mb-0">グループ{props.groupNo + 1}</h3>
            </div>
            <div className="card-body">
                <button type="button" name="addProcedure" className="btn btn-outline-secondary mb-2" onClick={handleAddProcedure}>
                    <FontAwesomeIcon icon="plus" />&nbsp;手順を追加する
                </button>
                {procedures}
            </div>
        </div>
    )
}

interface ListProps {
    yubinuki: Yubinuki,
    groupLength: number,

    onClickAddProcedure: ((groupNo: number) => void),

    onChangeOffset: ((procedureIndex: number, offset: number) => void),
    onChangeSasiType: ((procedureIndex: number, sasiType: number) => void),
    onChangeMatomeSasi: ((procedureIndex: number, matomeSasi: boolean) => void),
    onChangeConnectedRounds: ((procedureIndex: number, connectedRounds: number) => void),

    onClickMoveUpProcedure: ((procedureIndex: number) => void),
    onClickMoveDownProcedure: ((procedureIndex: number) => void),
    onClickDeleteProcedure: ((procedureIndex: number) => void),

    onChangeItoColor: ((procedureIndex: number, itoIndex: number, color: string) => void),
    onChangeItoRounds: ((procedureIndex: number, itoIndex: number, rounds: number) => void),
    onClickMoveUpIto: ((procedureIndex: number, itoIndex: number) => void),
    onClickMoveDownIto: ((proccedureIndex: number, itoIndex: number) => void),
    onClickDeleteIto: ((procedureIndex: number, itoIndex: number) => void),
    onClickAddIto: ((procedureIndex: number) => void),
}

function YubinukiProcedureGroupList(props: ListProps) {
    let groups: Array<Array<{ procedure: Procedure, index: number }>> = Array.from({ length: props.groupLength}).map((v, k)=>[]);
    let length = props.yubinuki.procedures.length;
    for (var i = 0; i < length; i++) {
        let procedure = props.yubinuki.procedures[i];
        groups[procedure.groupNo].push({ procedure: procedure, index: i });
    }

    let groupsRendered = groups.map((procedures, groupNo) => {
        return (
            <YubinukiProcedureGroup
                key={groupNo}
                groupNo={groupNo}
                procedures={procedures}
                tobi={props.yubinuki.tobi}

                onClickAddProcedure={props.onClickAddProcedure}

                onChangeOffset={props.onChangeOffset}
                onChangeSasiType={props.onChangeSasiType}
                onChangeMatomeSasi={props.onChangeMatomeSasi}
                onChangeConnectedRounds={props.onChangeConnectedRounds}
                onClickMoveUpProcedure={props.onClickMoveUpProcedure}
                onClickMoveDownProcedure={props.onClickMoveDownProcedure}
                onClickDeleteProcedure={props.onClickDeleteProcedure}
                onChangeItoColor={props.onChangeItoColor}
                onChangeItoRounds={props.onChangeItoRounds}
                onClickMoveUpIto={props.onClickMoveUpIto}
                onClickMoveDownIto={props.onClickMoveDownIto}
                onClickDeleteIto={props.onClickDeleteProcedure}
                onClickAddIto={props.onClickAddIto}
                />
        )
    });

    return <div>{groupsRendered}</div>
}

export default YubinukiProcedureGroupList;